<template>
  <div class="mt-5 mb-5">
    <div class="financial-disclosure-block">
      <p class="financial-disclosure-block__title mb-3"><strong>Financial advice disclosure statement</strong></p>
      <p class="financial-disclosure-block__content">Important information about the financial advice we provide. View our <a href="/disclosure-statement/" class="" target="_blank">disclosure statement</a>.</p>
    </div>
  </div>
</template>

<script>


export default {
  components: {

  },
  methods: {
  },
  data: function () {
    return {
    }
  },
}
</script>